import { AppPageShell, GlobalNotAuthorized } from "@/components/ui";
import { GlobalErrorPage } from "@/components/ui/GlobalErrorPage/GlobalErrorPage";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { ErrorBoundary } from "@sentry/react";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { massTortSearchId } = Route.useParams();
  const pathname = useLocation({ select: (location) => location.pathname });
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.massTortsDetail)) {
    return <GlobalNotAuthorized />;
  }

  const detailPath = pathname.slice(`/mass-torts/${massTortSearchId}`.length);
  const requiredPagePermission = getMassTortDetailPagePermission(detailPath);
  if (requiredPagePermission && !hasPagePermission(requiredPagePermission)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <ErrorBoundary fallback={<GlobalErrorPage />}>
      <Suspense
        fallback={
          <AppPageShell padding="none">
            <LawWorksLoader className="w-full" />
          </AppPageShell>
        }
      >
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
}

function getMassTortDetailPagePermission(path: string) {
  if (path === "" || path === "/") {
    return PAGE_PERMISSION_KEYS.massTortsDetailOverview;
  }
  if (path.startsWith("/tasks")) {
    return PAGE_PERMISSION_KEYS.massTortsDetailTasks;
  }
  if (path.startsWith("/surveys")) {
    return PAGE_PERMISSION_KEYS.massTortsDetailSurveys;
  }
  if (path.startsWith("/custom-fields")) {
    return PAGE_PERMISSION_KEYS.massTortsDetailCustomFields;
  }
  if (path.startsWith("/notes")) {
    return PAGE_PERMISSION_KEYS.massTortsDetailNotes;
  }
  if (path.startsWith("/file-generation")) {
    return PAGE_PERMISSION_KEYS.massTortsDetailFileGeneration;
  }
  if (path.startsWith("/files")) {
    return PAGE_PERMISSION_KEYS.massTortsDetailFiles;
  }
  return undefined;
}
